// extracted by mini-css-extract-plugin
export default {"button":"pk-z","reviewSort":"qk-z"};